import { render, staticRenderFns } from "./vinput_cif.vue?vue&type=template&id=1477dc03"
import script from "./vinput_cif.vue?vue&type=script&lang=js"
export * from "./vinput_cif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports